import { observer } from "mobx-react";
import * as React from "react";

import { ListVehicleProductivity } from "../ui/molecules/list-vehicle-productivity";
import { Section } from "../ui/atoms/section";
import { SelectionMode } from "@fluentui/react";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageVehicleProductivity extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[articles.truckFleetProductivityReport]}
                breadcrumb={store.i18n.t("page.vehicleProductivity.title")}
            >
                <Section fill>
                    <ListVehicleProductivity
                        selectionMode={SelectionMode.none}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
